import React from 'react'
import RecipeCreateLayoutContainer from "./RecipeCreateLayoutContainer";

const RecipeCreate = () => {

    return(
        <React.Fragment>
            <RecipeCreateLayoutContainer />
        </React.Fragment>
    )
}
export default RecipeCreate